import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HForm, { TextAreaField } from 'shared/containers/portal_layout/HForm';
import { reduxForm, FieldArray } from 'utils/reduxFormWrapper';
import api from 'utils/api';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import Errors from 'shared/components/Errors';
import FileAttachments from 'shared/components/Referrals/FileAttachments';
import buildFormDataFromNestedJSON from 'utils/buildFormDataFromNestedJSON';
import transformFileLists from 'utils/transformFileLists';
import SpinnerButton from 'shared/components/SpinnerButton';

class New extends Component {
  constructor(props, context) {
    super(props, context);
    this.createIncidentalFindings = this.createIncidentalFindings.bind(this);
  }

  createIncidentalFindings(formValues) {
    // FIXME: This assumes we have a browser with FormData, which means IE10+

    // Handle FileList conversion for multiple-file file inputs
    const allFormValues = {
      ...formValues,
      fileAttachmentsAttributes: transformFileLists(formValues.fileAttachmentsAttributes),
    };

    const formData = buildFormDataFromNestedJSON(allFormValues, 'incidental_finding');

    return api
      .post(
        `${this.props.apiEndpoint}/referrals/${this.props.referralId}/incidental_finding`,
        formData
      )
      .then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully created a report for this referral',
        });
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent
        form="createIncidentalFindings"
        onSubmit={this.createIncidentalFindings}
        initialValues={{
          fileAttachmentsAttributes: [{}],
        }}
      />
    );
  }
}

const PresentationComponent = props => (
  <HForm onSubmit={props.handleSubmit} data-spec-id="report-form">
    <div className="modal-header">
      <h3>Create Report</h3>
    </div>
    <div className="modal-body">
      <Errors errors={props.error || []} />
      <TextAreaField name="memo" label="Memo" className="input-xxlarge" rows={4} />
      <div className="control-group new-booking-form-group">
        <label className="control-label">Attach File(s)</label>
        <div className="controls">
          <FieldArray name="fileAttachmentsAttributes" component={FileAttachments} />
        </div>
      </div>
    </div>
    <div className="modal-footer">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Create Report
      </SpinnerButton>
    </div>
  </HForm>
);

PresentationComponent.displayName = 'PresentationComponent';

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

New.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  referralId: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};

export default New;
